import { setProcedureCondition } from "app/store/dashboard/surgery_types_procedures/slice/surgeryProcedureSlice";
import {
  EMPTY_RANGE,
  formatRangeValue,
  isFilterAtDefault,
  resolveFilterValue,
} from "app/store/dashboard/surgery_types_procedures/utils/filterValues";
import useActiveProcedure from "components/pages/dashboard/surgery_types_procedures/hooks/useActiveProcedure";

const useRangeFilter = (filter) => {
  const { procedureFilters, dispatch } = useActiveProcedure();
  const value = resolveFilterValue(filter, procedureFilters);
  const [start, end] = value;
  const step = filter.step ?? 1;

  const setRange = (nextRange) =>
    dispatch(setProcedureCondition({ field: filter.field, value: nextRange }));

  return {
    value,
    step,
    unit: filter.unit ?? "",
    badgeText: formatRangeValue(filter, value),
    isEmpty: isFilterAtDefault(filter, value),
    presets: filter.presets ?? [],
    presetsTitle: filter.presetsTitle,
    applyPreset: (preset) => setRange([...preset.value]),
    startBounds: { min: filter.min, max: (end ?? filter.max) - step },
    endBounds: { min: (start ?? filter.min) + step, max: filter.max },
    setStart: (nextStart) => setRange([nextStart, end]),
    setEnd: (nextEnd) => setRange([start, nextEnd]),
    reset: () => setRange([...EMPTY_RANGE]),
  };
};

export default useRangeFilter;
